import { render, staticRenderFns } from "./SpeechDare.vue?vue&type=template&id=63c49678&"
import script from "./SpeechDare.vue?vue&type=script&lang=ts&"
export * from "./SpeechDare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports